import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { captionLanguages } from '../../../common/constants';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const LanguageInput = () => {
  const { t } = useTranslation();
  const { project, updateStream } = useProject();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onChange = (option: Option) => {
    updateStream({ languageIsoCode: option.value });
  };

  return (
    <div className="language-input">
      <div className="input-title">
        {t('producer.inputs.language.title')}
        <Help
          title="Caption Source Language"
          text="Select the language of the spoken content."
        />
      </div>
      <Dropdown
        value={
          project?.stream?.sourceLanguageIsoCode || project?.encoder?.languageIsoCode || 'en-us'
        }
        options={captionLanguages}
        onChange={onChange}
        placeholderKey="producer.inputs.language.placeholder"
        readonly={!!project?.broadcastStartedUtc}
      />
      <div className="input-component-footer">{t('producer.inputs.language.footer')}</div>
    </div>
  );
};

export default React.memo(LanguageInput);
